import { Col, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import {
  DownloadIcon,
  DuplicateIcon,
  EditPennIcon,
  EmailIcon,
  PrintIcon,
} from "../../common/CustomIcon";
import IconClose from "../../../assets/images/IconClose.svg";
import EstimateDetails from "./EstimateDetails";
import Button_v2 from "./Button_v2";
import { printQuoteOrdersPdf } from "../../api/Billing";
import { alertMessage, base64ToPdf, isEmpty } from "../../common/Common";
import InvoiceDetailsDrawer from "./InvoiceDetailsDrawer";
import QuoteModelDetails from "./orders/QuoteModelDetails";
import { fetchOrganizationDetails } from "../../api/Organisations";
import userStore from "../../stores/UserStore";
import AppConfig from "../../config/AppConfig";
import { base64ToPDF, renderAlertMessage } from "../../helpers/common";
import { QuotesApis } from "../../api/QuotesApi";
import EmailQuote from "../../components/quotes/EmailQuote";

const OrderDetailsDrawer = ({
  viewTab,
  setShowDrawer,
  orderResponse,
  refreshDetails,
  account,
  showDrawer
}) => {
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false)
  const [saveCall, setSaveCall] = useState(false)
  const [logo, setLogo] = useState(null);
  const [revisions, setRevisions] = useState([]);
  const [quote_activities, setQuote_activities] = useState([]);
  const [currentQuote, setCurrentQuote] = useState(null);
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  
  const resetValues = (closeModal = false) => {
    setShowInfoWindow(false);
  };

  const handleEditMode = (val) => {
    setIsEdit(val);
  }

  const handleSaveCall = (val) => {
      setSaveCall(val)
  }

  const handleSendingMails = async () => {
    try {
      const payload = {
        quote_id,
        emails: emails.join(","),
      };
      setLoading(true);
      let response = await QuotesApis.emailQuote(quote_id, payload);
      if (response.success) {
        const result = response?.data ? response.data : {};
        const successMessage = result?.message
          ? result.message
          : I18n.t("messages.saved");
        //  typeof onSave === 'function' && onSave(I18n.t('messages.saved'))
        if (result.errors && result.errors.length > 0) {
          setErrors(result.errors);
        } else {
          alertMessage(successMessage, "success", 5);
          resetValues();
          setShowInfoWindow(false);
        }
      } else {
        setErrors([...response.errors]);
        // throw new Error(response.errors[0])
      }
    } catch (error) {
      alertMessage(error.message, "error", 10);
    } finally {
      setLoading(false);
    }
  };

  const handleEmailModal = (val) => {
    setOpenEmailModal(val);
  };

  const updateIndAccessorials = (revisionsData) => {
    const revs = revisionsData.map((revsionObj) => {
      revsionObj.ori_accessorial_charges =
        revsionObj?.ind_accessorial_charges &&
        _.isArray(revsionObj.ind_accessorial_charges)
          ? [...revsionObj.ind_accessorial_charges]
          : [];
      const ind_accessorial_charges = {};
      if (
        !isEmpty(revsionObj.ind_accessorial_charges) &&
        _.isArray(revsionObj.ind_accessorial_charges)
      ) {
        revsionObj.ind_accessorial_charges.forEach((charge) => {
          let loc_id = charge.location_id;
          // if(isEmpty(loc_type)){
          //   const typeOfOrder = _.get(currentQuote, "quote.type_of_order", '')
          //   loc_type = ['D','TD'].includes(typeOfOrder) ? 'DELIVERY' : 'PICKUP'
          // }
          if (loc_id) {
            if (!ind_accessorial_charges[charge.accessorial]) {
              ind_accessorial_charges[charge.accessorial] = {};
            }
            ind_accessorial_charges[charge.accessorial][loc_id] =
              charge.accessorial_charge;
          } else {
            ind_accessorial_charges[charge.accessorial] =
              charge.accessorial_charge;
          }
        });
      }
      revsionObj.ind_accessorial_charges = ind_accessorial_charges;
      return { ...revsionObj };
    });
    return revs;
  };

  const getOrgLogo = () => {
    const orgId = userStore.getStateValue("selectedOrg");
    fetchOrganizationDetails(orgId).then((result) => {
      if (result.success) {
        const organization = result.organization || {};
        organization.logo =
          !isEmpty(organization.logo) && organization.logo.url
            ? organization.logo.url
            : "";

        if (organization.logo) {
          setLogo(organization.logo);
        } else if (!isEmpty(orgId)) {
          const urlToFile = `${AppConfig.baseUrl}/org_logos/${orgId}/org_logo.png`;
          fetch(urlToFile).then((response) => {
            if (response.status === 200) {
              setLogo(urlToFile);
            }
          });
        }
      }
    });
  };

  const getQuoteDetails = (quote_id) => {
    try {
      setLoading(true)
      QuotesApis.fetchone(quote_id).then((result) => {
        if (result.success) {
          const quoteDetails = result.data || {};
          const revisions =
            !isEmpty(quoteDetails.quote) && quoteDetails.quote.quotes
              ? quoteDetails.quote.quotes
              : [];
          const quotesActivities = !isEmpty(quoteDetails.quote_activities)
            ? quoteDetails.quote_activities
            : [];
          setQuote_activities(quotesActivities);

          setCurrentQuote(quoteDetails);

          const revs = updateIndAccessorials(revisions);
          // const quotesActiv = updateIndAccessorials(quotesActivities)
          setRevisions([...revs]);

          setQuote_activities(quotesActivities);
          //setSummaryDetails(newSummaryDetails);
          // setShowInfoWindow(true)
          setLoading(false)
        } else {
          setLoading(false)
          renderAlertMessage(result.errors);
        }
      });
    } catch (error) {
      setLoading(false)
      alertMessage(error.message, "error", 10);
    }
  };

  const cloneQuote = (id) => {
    QuotesApis.QuoteCreate(id).then((result) => {
      if (result.success) {
        alertMessage(`Quote Created Successfully`);
      } else {
        this.setState({ inProgress: false });
      }
    });
  };

  const downloadQuote = () => {
    QuotesApis.downloadQuote(
      orderResponse.customer_order_details?.quote_id
    ).then((result) => {
      if (result.success) {
        base64ToPDF(
          result.quote_file,
          `Quote_${orderResponse?.customer_order_details?.quote_order_number}.pdf`
        );
      } else {
        renderAlertMessage(result.errors);
      }
    });
  };

  useEffect(() => {
    if(viewTab === "quote"){
      getOrgLogo();
      getQuoteDetails(orderResponse.customer_order_details?.quote_id);
    }
  }, []);

  const handlePrintBills = async (id) => {
    // const selectedIds = !isEmpty(orderIds) ? orderIds : [];
    try {
      let result = await printQuoteOrdersPdf(id);
      if (result.success) {
        base64ToPdf(
          result.quote_orders_pdf,
          `BillingEstimates-${moment().format("YYYY-MM-DDTHH:mm:ss")}.pdf`
        );
      } else {
        if (result.errors.length > 0) {
          alertMessage(result.errors.join(", "), "error", 10);
        }
      }
    } catch (error) {
      alertMessage(error.message, "error", 10);
    } finally {
    }
  };

  const renderEstimate = () => {
    return (
      <Spin spinning={loading}>
      <>
        <Row
          className="drawer-header"
          type="flex"
          align="middle"
          justify="space-between"
          
        >
          <Col>
            <Row type="flex" align="middle" gutter={16}>
              <Col>
                <img src={IconClose} onClick={() => {setShowDrawer(false); handleEditMode(false); handleSaveCall(false)}} style={{ cursor: "pointer" }} />
              </Col>
              <Col className="drawer-header-title">Estimate</Col>
            </Row>
          </Col>
          <Col>
          {!isEdit ?
                        <Row gutter={16} type="flex">
                            <Button_v2
                                className="small-btn flat"
                                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                onClick={() => handlePrintBills(orderResponse.id)}
                            >
                                <PrintIcon height="16" width="16" color="#617AD6" />
                                Print
                            </Button_v2>
                            <Button_v2
                                className="small-btn flat"
                                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                onClick={() => handleEmailModal(true)}
                            >
                                <EmailIcon height="16" width="16" color="#617AD6" />
                                Email
                            </Button_v2>
                            {/* <Button_v2
                                className="small-btn flat"
                                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                onClick={() => handleEditMode(true)}
                            >
                                <EditPennIcon height="16" width="16" color="#617AD6" />
                                Edit
                            </Button_v2> */}
                        </Row>
                        :
                        <Row gutter={16} type="flex">
                            <Col>
                                <Button_v2
                                    className="small-btn flat"
                                    onClick={() => {handleEditMode(false); handleSaveCall(false)}}
                                    text={'Cancel'}
                                />
                            </Col>
                            <Col>
                                <Button_v2
                                    className="small-btn raised"
                                    onClick={() => handleSaveCall(true)}
                                    text={'Save'}
                                />
                            </Col>
                        </Row>
                    }
          </Col>
        </Row>
        <Row className="drawer-body">
          <EstimateDetails
            order={orderResponse}
            order_id={orderResponse.id}
            callInvoceDetails={true}
            showHeading={false}
            showOtherDetails={false}
            updateQuote={(id, amount) =>
              // this.updateQuote(id, amount, details.key)
              refreshDetails()
            }
            setData={false}
            openEmailModal={openEmailModal}
            handleEmailModal={handleEmailModal}
            account={account}
            editMode={isEdit}
            showDrawer={showDrawer}
            saveCall={saveCall}
            handleSaveCall={handleSaveCall}
            activeKey="billing"
            // activeKey={activeKey}
          />
        </Row>
      </>
      </Spin>
    );
  };

  const renderQuote = () => {
    return (
      <Spin spinning={loading}>
      <>
        <Row
          className="drawer-header"
          type="flex"
          align="middle"
          justify="space-between"
        >
          <Col>
            <Row type="flex" align="middle" gutter={16}>
              <Col>
                <img
                  src={IconClose}
                  onClick={() => setShowDrawer(false)}
                  style={{ cursor: "pointer" }}
                />
              </Col>
              <Col className="drawer-header-title">
                Quote:{" "}
                #{orderResponse?.customer_order_details?.quote_order_number}
              </Col>
            </Row>
          </Col>
          <Col>
            <Row gutter={16} type="flex">
              {/* CLone Icon */}
              <Button_v2
                className="small-btn flat"
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
                onClick={() =>
                  cloneQuote(orderResponse.customer_order_details?.quote_id)
                }
              >
                <DuplicateIcon height="16" width="16" color="#617AD6" />
                Clone
              </Button_v2>
              {/* Download Icon */}
              <Button_v2
                className="small-btn flat"
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
                onClick={downloadQuote}
              >
                <DownloadIcon height="16" width="16" color="#617AD6" />
                Download
              </Button_v2>
              {/* Email Icon */}
              <Button_v2
                  className="small-btn flat"
                  style={{ 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "8px",
                  }}
                >
                  <EmailQuote
                   key={`email${orderResponse?.customer_order_details?.quote_id}`}
                   quote_id={orderResponse?.customer_order_details?.quote_id}
                   quote_no={
                     orderResponse?.customer_order_details?.quote_order_number
                   }
                    color="#617AD6"
                    style={{
                      marginRight: 2,
                      flexShrink: 0 
                    }}
                  />
              </Button_v2>
            </Row>
          </Col>
        </Row>
        <Row className="drawer-body">
       { orderResponse &&  <QuoteModelDetails
            logo={logo}
            quoteId={orderResponse?.id}
            orderResponse={orderResponse}
            currentQuote={currentQuote}
            revisions={revisions}
            quote_activities={quote_activities}
          />}
        </Row>
      </>
      </Spin>
    );
  };

  return (
    <>
      {viewTab === "estimate" && renderEstimate()}
      {viewTab === "quote" && renderQuote()}
        {viewTab === "invoice" && 
            <InvoiceDetailsDrawer
                order={orderResponse}
                closeDrawer={() => setShowDrawer(false)}
                handleIsLosChanged={() => { }}
                account={orderResponse.account}
                refreshDetails={refreshDetails}
            />
        }
    </>
  );
};

export default OrderDetailsDrawer;